<template>
    <div class="copy-some">
        <el-tooltip class='item' effect="dark" content="复制" placement="top"><i class="el-icon-document-copy"
                :style="{ marginLeft: '0.1rem', cursor: 'pointer', color }" @click="copySome(copyData)"></i></el-tooltip>
    </div>
</template>

<script>
export default {
    name: 'CopySome',
    props: {
        v: {
        },
        color: {
            type: String,
            default: '#409EFF'
        }
    },
    data() {
        return {
            copyData: '',
        }
    },
    methods: {
        // 复制功能
        copy(data) {
            // 存储传递过来的数据
            let OrderNumber = data
            // 创建一个input 元素
            // createElement() 方法通过指定名称创建一个元素
            let newInput = document.createElement('input')
            // 讲存储的数据赋值给input的value值
            newInput.value = OrderNumber
            // appendChild() 方法向节点添加最后一个子节点。
            document.body.appendChild(newInput)
            // 选中input元素中的文本
            // select() 方法用于选择该元素中的文本。
            newInput.select()
            // 执行浏览器复制命令
            //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
            document.execCommand('Copy')
            // 清空输入框
            newInput.remove()
            // 下面是element的弹窗 不需要的自行删除就好
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        copySome(data) {
            this.copy(data)
        },
    },
    watch: {
        // v(n) {
        //     this.copyData = n
        //     console.log(n)
        // }
        v: {
            immediate: true,
            handler(n) {
                this.copyData = n
            }
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/commonReform/CopySome.vue